import { PureLightTheme } from "../../../../styles/theme"
import { COLORS } from "../../../../styles/variables"

export const MainStack = {
    marginBottom: 2,
    alignItems: "center",
    [PureLightTheme.breakpoints.down("md")]: {
        marginBottom: 0,
    },
    '@media (max-width:1100px)': {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1,
    },
}

export const SelectStyle = {
    "& .MuiSelect-icon": {
        top: '50%',
        transform: 'translateY(-50%)',
        color: COLORS.PICTON_BLUE,
        width: '6px',
        height: '3px',
    },
    '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
        paddingLeft: '0px',
        paddingRight: '20px',
    },
    fontSize: "12px",
    fontWeight: 400,
    color: COLORS.PICTON_BLUE,
    border: 'none',
    cursor: 'default',
}

export const MenuPaperStyled = {
    borderRadius: '12px',
    marginTop: 1,
}

export const MenuListStyled = {
    display: 'grid',
    padding: '12px',
    gap: 1,
    '& .MuiMenuItem-root': {
        width: 'fit-content',
        alignSelf: 'start',
    },
}

export const MenuItemStyled = {
  borderRadius: '20px',
  color: COLORS.BLACK,
  fontWeight: 400,
  fontSize: '14px',
  [PureLightTheme.breakpoints.down("sm")]: {
        fontSize: '14px',
    }
}
